import { useState } from 'react'
import { classNames } from '~/helpers/string'

export type AvatarProps = {
  name?: string
  src?: string
  alt?: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const getInitials = (name: string) => {
  return name
    .split(' ')
    .map((word) => word[0])
    .slice(0, 2)
    .join('')
    .toUpperCase()
}

const sizeClasses = {
  sm: 'max-h-5 max-w-5 min-h-5 min-w-5 h-5 w-5 text-xs',
  md: 'max-h-10 max-w-10 min-h-10 min-w-10 h-10 w-10 text-sm',
  lg: 'max-h-[60px] max-w-[60px] min-h-[60px] min-w-[60px] h-[60px] w-[60px] text-xl',
}

export const Avatar = (props: AvatarProps) => {
  const { name, src, alt, size = 'md', className = '' } = props
  const [imageError, setImageError] = useState(false)
  const initials = name ? getInitials(name) : null

  return (
    <div
      className={classNames(
        'flex items-center justify-center overflow-hidden rounded-full border border-brand-purple-100 bg-brand-purple-100 text-brand-purple-700',
        sizeClasses[size],
        className,
      )}
    >
      {src && !imageError ? (
        <img src={src} alt={alt || name} onError={() => setImageError(true)} className="h-full w-full object-cover" />
      ) : initials ? (
        <span className="text-brand-purple-700">{initials}</span>
      ) : (
        <svg className="h-full w-full" viewBox="0 0 24 24">
          <path
            id="my-profile"
            d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0ZM8,10a4,4,0,0,1,8,0v1a4,4,0,0,1-8,0Zm4,12a9.955,9.955,0,0,1-6.4-2.326A4.98,4.98,0,0,1,10,17h4a4.98,4.98,0,0,1,4.4,2.674A9.955,9.955,0,0,1,12,22Z"
            fill="currentColor"
          />
        </svg>
      )}
    </div>
  )
}
